import axios from "axios";
import http from "http";
import _ from "lodash";
import getUserConfig from "./getUserConfig";

const getUserDetails = async (emp_id) => {
    if (_.isEmpty(emp_id) || emp_id === undefined) {
      return [];
    }
    let resp = await axios.request({url: `https://udc-server.herokuapp.com/udc/user/${emp_id}`,
      method: 'GET',
      headers: {
        'Content-Type':'application/json',
        'withCredentials': true, 
        'Access-Control-Allow-Origin': '*'
      },
      httpAgent: new http.Agent({ keepAlive: true })
    });
    resp = await resp.data;
    if (!_.isEmpty(resp)){
      let config = await getUserConfig(emp_id);
      resp['config'] = config;
      return resp;
    } else {
      return [];
    }
  }

  export default getUserDetails;